import React, { Component } from "react";
import { Accessor, ColorX, FilterX, GFunc, LocaleX, ZTime } from "../../../../STATIC";
import PropsType from "prop-types";
import FilterizoIconX from "../FilterizoIconX";
import styles from "../_style/filterizo";
import _ from "lodash";
import PopupListSelector from "../../../Libs/PopupListSelector/PopupListSelector";
import { XText, HStack, XButton, XInput } from "../../../../_X";
import { Calendarizo } from "../..";

/**
 * @augments {Component<Props, State>}
 */
class OneFilterSelector extends Component {

  static propTypes = {
    ischema: PropsType.any,
    rule: PropsType.any,
    addOns: PropsType.any,
    onFilterChange: PropsType.func,
    style: PropsType.any
  }

  static defaultProps = {
    ischema: {},
    rule: {},
    addOns: {},
    onFilterChange: null,
    style: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(OneFilterSelector.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(OneFilterSelector.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _GetChoices = () => {
    let {rule} = this.props;
    let choices = FilterX.GetSelectRef(rule.format);
    let selectedChoice = _.find(choices, o => o.val === rule.operator);
    return {choices, selectedChoice};
  }

  _onFilterChange = (filter) => {
    let {onFilterChange} = this.props;
    onFilterChange?.(filter);
  }

  _onOperSelect = (choice) => {
    let {rule} = this.props;
    let {val} = choice;
    this._onFilterChange({
      ...rule,
      operator: val,
      value: null
    });
    GFunc.CloseBackdrop();
  }

  _openOperSelect = (choices) => {
    GFunc.Backdrop(() => {
      return (
        <PopupListSelector
          choices={choices}
          onSelect={this._onOperSelect}
          selectVal="val"
          renderer={(choice) => {
            return (
              <HStack style={{padding: 10}}>
                <XText style={styles.popbtntext}>
                  {LocaleX.Parse(choice.cap)}
                </XText>
              </HStack>
            );
          }}  
          />
      );
    }, {}, true, false);
  }

  _onValueChange = (value) => {
    let {rule} = this.props;
    this._onFilterChange({
      ...rule,
      value: value
    });
    GFunc.CloseBackdrop();
  }

  _onSelectValueChange = (choice) => {
    let {rule, ischema} = this.props;
    let {selectVal} = ischema;
    let value = Accessor.Get(choice, selectVal);
    this._onFilterChange({
      ...rule,
      value: value
    });
    GFunc.CloseBackdrop();
  }

  _onSelectRDPeriodChange = (choice) => {
    let {rule} = this.props;
    this._onFilterChange({
      ...rule,
      value: {
        ...rule.value, 
        period: choice.val
      }
    });
    GFunc.CloseBackdrop();
  }

  _onSelectRDUnitChange = (choice) => {
    let {rule} = this.props;
    this._onFilterChange({
      ...rule,
      value: {
        ...rule.value, 
        unit: choice.val
      }
    });
    GFunc.CloseBackdrop();
  }

  _openValueSelect = (choices) => {
    let {ischema} = this.props;
    let {selectCap, selectVal, selectFilterFunc, selectRenderer, allowSearch} = ischema;
    let defaultFuncFilter = (choice, search) => {
      return FilterX.TextSearchForFields(choice, 
        [
          selectCap,
          selectCap + ".EN",
          selectCap + ".TC",
          selectVal
        ], search);
    };
    let defaultRenderer = (choice) => {
      let cap = Accessor.Get(choice, selectCap);
      return (
        <HStack style={{padding: 10}}>
          <XText style={styles.popbtntext}>
            {LocaleX.Parse(cap)}
          </XText>
        </HStack>
      );
    };
    let _renderer = selectRenderer ?? defaultRenderer;
    let _filterFunc = selectFilterFunc ?? defaultFuncFilter;
    GFunc.Backdrop(() => {
      return (
        <PopupListSelector 
          allowSearch={allowSearch}
          choices={choices}
          onSelect={this._onSelectValueChange}
          filterFunc={_filterFunc}
          renderer={_renderer}  
          selectVal={selectVal}
          />
      );
    });
  }

  _openRDPeriod = () => {
    GFunc.Backdrop(() => {
      return (
        <PopupListSelector
          choices={FilterX.__Period}
          onSelect={this._onSelectRDPeriodChange}
          selectVal="val"
          renderer={(choice) => {
            return (
              <HStack style={{padding: 10}}>
                <XText style={styles.popbtntext}>
                  {LocaleX.Parse(choice.cap)}
                </XText>
              </HStack>
            );
          }}  
          />
      );
    }, {}, true, false);
  }

  _openRDUnit = () => {
    GFunc.Backdrop(() => {
      return (
        <PopupListSelector
          choices={FilterX.__Unit}
          onSelect={this._onSelectRDUnitChange}
          selectVal="val"
          renderer={(choice) => {
            return (
              <HStack style={{padding: 10}}>
                <XText style={styles.popbtntext}>
                  {LocaleX.Parse(choice.cap)}
                </XText>
              </HStack>
            );
          }}  
          />
      );
    }, {}, true, false);
  }

  _openValueDate = () => {
    GFunc.Backdrop(() => {
      return (
        <Calendarizo
          directConfirm={true}
          onConfirm={(selectedDate) => this._onValueChange(selectedDate)}
          />
      );
    }, {}, true, false);
  }

  _openValueDateRange = () => {
    GFunc.Backdrop(() => {
      return (
        <Calendarizo
          directConfirm={true}
          onConfirm={(selectedDate) => this._onValueChange({
            from: selectedDate.start,
            to: selectedDate.end
          })}
          range
          />
      );
    }, {}, true, false);
  }

  renderIcon(){
    let {rule} = this.props;
    let size = 15;
    let color = ColorX.CSS("skyBlue");
    return FilterizoIconX.Get(rule.format, size, color);
  }

  renderLabel(){
    let {rule} = this.props;
    return (
      <XText style={styles.oneFilterLabel}>
        {LocaleX.Parse(rule.label) + ":"}
      </XText>
    );
  }

  renderOperator(choices, selectedChoice){
    let {cap} = selectedChoice ?? {};
    return (
      <XButton style={styles.operbtn} hoverMode="darken"
        color={ColorX.CSS("gambot2Blue", 0.1)}
        fullHeight
        onPress={() => this._openOperSelect(choices)}>
        <XText style={styles.operbtntext} ellipsisMode="ellipsis">
          {LocaleX.Parse(cap)}</XText>
      </XButton>
    );
  }

  renderValueNumber(){
    let {rule} = this.props;
    let {value = 0} = rule;
    return (
      <XInput onChangeText={(text) => this._onValueChange(text)} 
        value={value} style={styles.inputText} 
        numberOfLines={1} keyboardType="number-pad"/>
    );
  }

  renderValueText(){
    let {rule} = this.props;
    let {value = ""} = rule;
    return (
      <XInput onChangeText={(text) => this._onValueChange(text)} 
        value={value} style={styles.inputText}
        numberOfLines={1}/>
    );
  }

  renderValueSelect(){
    let {rule, ischema, addOns} = this.props;
    let {selectRef, selectVal, selectCap} = ischema;
    let choices = [];
    if(_.isString(selectRef)){
      choices = addOns?.[selectRef] ?? [];
    }else{
      if(_.isArray(selectRef)){
        choices = selectRef;
      }
    }
    let selectedChoice = null;
    if(rule.value){
      selectedChoice = _.find(choices, o => Accessor.Get(o, selectVal) === rule.value);
    }
    return (
      <XButton style={styles.valueselectbtn} 
        onPress={() => this._openValueSelect(choices)}>
        <HStack>
          <XText 
            style={selectedChoice ?
              styles.valueselecttext :
              styles.valueselectnulltext}
              ellipsisMode="ellipsis">
            {
            selectedChoice ? 
              LocaleX.Parse(Accessor.Get(selectedChoice, selectCap))
              :
              LocaleX.Parse({
                EN: "not selected yet",
                TC: "尚未選擇"
              })}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderValueDate(){
    let {rule} = this.props;
    let value = rule?.value;
    return (
      <XButton style={styles.valueselectbtn} 
        hoverBgColor={ColorX.CSS("greyOut", 0.2)}
        onPress={() => this._openValueDate()}>
        <XText numberOfLines={1}
          style={value ?
            styles.valueselecttext :
            styles.valueselectnulltext}>
          {value ? 
            ZTime.Locale(value, "ll")
            :
            LocaleX.Parse({
              EN: "not selected yet",
              TC: "尚未選擇"
            })}
        </XText>
      </XButton>
    );
  }

  renderValueDateRange(){
    let {rule} = this.props;
    let value = rule?.value;
    return (
      <XButton style={styles.valueselectbtn} 
        hoverBgColor={ColorX.CSS("greyOut", 0.2)}
        onPress={() => this._openValueDateRange()}>
        <XText numberOfLines={1}
          style={value ?
            styles.valueselecttext :
            styles.valueselectnulltext}>
          {value ? 
            ZTime.Locale(value?.from, "D MMM") + " - " + ZTime.Locale(value?.to, "D MMM")
            :
            LocaleX.Parse({
              EN: "not selected yet",
              TC: "尚未選擇"
            })}
        </XText>
      </XButton>
    );
  }

  renderValueRelativeDate(){
    let {rule} = this.props;
    let value = rule?.value;
    let {period, unit} = value ?? {};
    let selectedPeriod = _.find(FilterX.__Period, o => o.val === period);
    let selectedUnit = _.find(FilterX.__Unit, o => o.val === unit);
    return (
      <HStack style={{flex: 1}}>
        <XButton style={styles.rdperiodbtn} 
          hoverBgColor={ColorX.CSS("greyOut", 0.2)}
          onPress={() => this._openRDPeriod()}>
          <XText numberOfLines={1}
            style={selectedPeriod ?
              styles.valueselecttext :
              styles.valueselectnulltext}>
            {selectedPeriod ? 
              LocaleX.Parse(selectedPeriod?.cap)
              :
              "---"}
          </XText>
        </XButton>
        <XButton style={styles.rdselectbtn} 
          hoverBgColor={ColorX.CSS("greyOut", 0.2)}
          onPress={() => this._openRDUnit()}>
          <XText numberOfLines={1}
            style={selectedUnit ?
              styles.valueselecttext :
              styles.valueselectnulltext}>
            {selectedUnit ? 
              LocaleX.Parse(selectedUnit?.cap)
              :
              "---"}
          </XText>
        </XButton>
      </HStack>
    );
  }

  renderValue(){
    let {rule} = this.props;
    let {format, operator} = rule;
    let valueType = FilterX.GetValueType(format, operator);
    switch(valueType){
      case "number": return this.renderValueNumber();
      case "none": return;
      default: case "text": return this.renderValueText();
      case "select": return this.renderValueSelect();
      case "date": return this.renderValueDate();
      case "dateRange": return this.renderValueDateRange();
      case "relativeDate": return this.renderValueRelativeDate();
    }
  }

  render(){   
    let {style, typeIcon} = this.props;
    let {choices, selectedChoice} = this._GetChoices();
    return (
      <HStack spacing={5} style={{
        ...styles.onefilter, 
        ...style
      }} justifyContent={"flex-start"}>
        {typeIcon && this.renderIcon()}
        {this.renderLabel()}
        {this.renderOperator(choices, selectedChoice)}
        {this.renderValue()}
      </HStack>
    );
  }
}

export default OneFilterSelector;
